import { CheckCircleIcon, XMarkIcon } from '@heroicons/react/20/solid';
import { AlertProps } from './index';

export default function SuccessAlert(props: Pick<AlertProps, 'label' | 'close'>) {
  const { label, close } = props;
  return (
    <div className="relative flex items-center gap-3 rounded-md bg-green-50 p-4">
      <CheckCircleIcon className="size-6 flex-shrink-0 text-green-400" aria-hidden="true" />
      <p className="text-sm font-medium text-green-800">{label}</p>
      <button
        type="button"
        onClick={close}
        className="inline-flex rounded-md bg-green-50 p-1.5 text-green-500 hover:bg-green-100 focus:outline-none focus:ring-2 focus:ring-green-600 focus:ring-offset-2 focus:ring-offset-green-50"
      >
        <span className="sr-only">Dismiss</span>
        <XMarkIcon className="size-5 flex-shrink-0" aria-hidden="true" />
      </button>
    </div>
  );
}
